<template>
  <div class="custom-control custom-checkbox align-items-center" :disabled="disabled">
    <input
      :id="id || name"
      :name="name"
      :checked="internalValue"
      :disabled="disabled"
      type="checkbox"
      class="custom-control-input"
      @click="handleClick"
      @change="handleChange"
    >
    <label :for="id || name" class="custom-control-label text-small" :disabled="disabled">
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  name: 'Checkbox',

  props: {
    id: { type: String, default: null },
    name: { type: String, default: 'checkbox' },
    value: { type: Boolean, default: false },
    checked: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },

  data: () => ({
    internalValue: false
  }),

  watch: {
    value (val) {
      this.internalValue = val
    },

    checked (val) {
      this.internalValue = val
    },

    internalValue (val, oldVal) {
      if (val !== oldVal) {
        this.$emit('input', val)
      }
    }
  },

  created () {
    this.internalValue = this.value

    if ('checked' in this.$options.propsData) {
      this.internalValue = this.checked
    }
  },

  methods: {
    handleClick (e) {
      this.$emit('click', e)

      if (!e.isPropagationStopped) {
        this.internalValue = e.target.checked
      }
    },
    handleChange (e) {
      this.$emit('change', e);

      if (!e.isPropagationStopped) {
        this.internalValue = e.target.checked
      }
    }
  }
}
</script>
